import gql from "graphql-tag";

export const UPDATE_TERMS_AND_CONDITION_FLAG = gql`
  mutation term_and_conditions(
    $user_id: uuid = ""
    $term_and_conditions: Boolean = false
  ) {
    update_users(
      where: { id: { _eq: $user_id } }
      _set: { term_and_conditions: $term_and_conditions }
    ) {
      affected_rows
      returning {
        id
        term_and_conditions
      }
    }
  }
`;
